// PurposeSection.jsx:
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import image1 from '../assets/image1.jpeg';
import image2 from '../assets/image2.jpeg';
import image3 from '../assets/image3.jpeg';
import image4 from '../assets/image4.jpeg';
import image5 from '../assets/image5.jpeg';
import './PurposeSection.css';

function PurposeSection() {
    const { t } = useTranslation(); // Translation hook

    const slides = [
        {
            title: t("purpose.what_is_ever.title"),
            intro: t("purpose.what_is_ever.intro"),
            description: t("purpose.what_is_ever.description", { returnObjects: true })
        },
        {
            title: t("purpose.why_use_ever.title"),
            intro: t("purpose.why_use_ever.intro"),
            description: t("purpose.why_use_ever.description", { returnObjects: true })
        },
        {
            title: t("purpose.when_to_use_ever.title"),
            intro: t("purpose.when_to_use_ever.intro"),
            description: t("purpose.when_to_use_ever.description", { returnObjects: true })
        },
        {
            title: t("purpose.where_is_ever_available.title"),
            intro: t("purpose.where_is_ever_available.intro"),
            description: t("purpose.where_is_ever_available.description", { returnObjects: true })
        },
        {
            title: t("purpose.how_to_use_ever.title"),
            intro: t("purpose.how_to_use_ever.intro"),
            description: t("purpose.how_to_use_ever.description", { returnObjects: true })
        },
        {
            title: t("purpose.who_uses_ever.title"),
            intro: t("purpose.who_uses_ever.intro"),
            description: t("purpose.who_uses_ever.description", { returnObjects: true })
        }
    ];

    return (
        <div className="purpose-container">
            <section className="purpose-section">
                <h2>{t("purpose.heading")}</h2>
                <p className="purpose-description">{t("purpose.description")}</p>

                {/* Image Gallery with Overlay Text */}
                <div className="image-gallery">
                    <div className="gallery-img1">
                        <img src={image1} alt="Service 1" className="gallery-img1a" />
                        <div className="image-text1">{t("purpose.image1")}</div>
                    </div>
                    <div className="gallery-img2">
                        <img src={image2} alt="Service 2" className="gallery-img2a" />
                        <div className="image-text2">{t("purpose.image2")}</div>
                    </div>
                    <div className="gallery-img3">
                        <img src={image3} alt="Service 3" className="gallery-img3a" />
                        <div className="image-text3">{t("purpose.image3")}</div>
                    </div>
                    <div className="gallery-img4">
                        <img src={image4} alt="Service 4" className="gallery-img4a" />
                        <div className="image-text4">{t("purpose.image4")}</div>
                    </div>
                    <div className="gallery-img5">
                        <img src={image5} alt="Service 5" className="gallery-img5a" />
                        <div className="image-text5">{t("purpose.image5")}</div>
                    </div>
                </div>
            </section>

            {/* Horizontal Slider Section */}
            <div className="horizontal-slider">
                <Swiper
                    modules={[Autoplay, Navigation, Pagination]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 6000, disableOnInteraction: false }}
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index} className="slide">
                            <div className="slide-content">
                                <h3>{slide.title}</h3>
                                <p>{slide.intro}</p>
                                <ul>
                                    {slide.description.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default PurposeSection;
